import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface TutorialStep {
	title: string;
	description: string;
}

interface TutorialVideoProps {
	title: string;
	description: string;
	videoUrl: string;
	steps: TutorialStep[];
	className?: string;
}

export function TutorialVideo({
	title,
	description,
	videoUrl,
	steps,
	className,
}: TutorialVideoProps) {
	return (
		<Card className={cn("w-full", className)}>
			<CardHeader>
				<CardTitle>{title}</CardTitle>
				<CardDescription>{description}</CardDescription>
			</CardHeader>
			<CardContent className="space-y-6">
				<div className="relative mx-4 p-8 pb-[56.25%] max-w-lg">
					<iframe
						title={title}
						src={videoUrl}
						allowFullScreen
						className="top-0 left-0 absolute rounded-lg w-full h-full"
					/>
				</div>

				<div className="space-y-4">
					<h3 className="font-semibold text-lg">Step-by-Step Instructions</h3>
					<div className="space-y-4">
						{steps.map((step) => (
							<div key={step.title} className="space-y-2">
								<div className="flex items-start gap-4">
									<div className="flex flex-shrink-0 justify-center items-center bg-indigo-100 dark:bg-indigo-900 rounded-full w-8 h-8 font-medium text-indigo-700 dark:text-indigo-300">
										{steps.indexOf(step) + 1}
									</div>
									<div className="flex-1 space-y-2">
										<h4 className="font-medium text-slate-900 dark:text-slate-100">
											{step.title}
										</h4>
										<p className="text-slate-600 dark:text-slate-400">
											{step.description}
										</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</CardContent>
		</Card>
	);
}
